import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat.id;

const getSelectedChatId = createSelector(getData, chatId => chatId);

export default getSelectedChatId;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getSelectedChatId.js